import React from "react";
import styles from "./FollowersCard.module.scss";
import { profilePortfolioAPI } from "../../../service/apiUrl";
import { serverFiles } from "../../../utils/utils";
import { Link } from "react-router-dom";
import NO_IMAGE from "../../../images/NO_IMAGE.jpg";

const FollowersCard = ({
  firstName,
  lastName,
  profileUrl,
  industry,
  userAliasId,
}) => {
  return (
    <div className={styles.FollowerCard}>
      <img
        src={serverFiles(profileUrl) || NO_IMAGE}
        alt="profile"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = NO_IMAGE;
        }}
      />
      <Link to={`/user-profile/${userAliasId}`} className={styles.textSection}>
        <p className={styles.first_last_name}>
          {firstName} {lastName}
        </p>
        <p className={styles.industry}>{industry ? industry[0] : ""}</p>
      </Link>
    </div>
  );
};

export default FollowersCard;
